module.exports = __webpack_public_path__ + "static/media/dropdown-large.02650487.svg";